import ApplicationLogout from './logout/ApplicationLogout';

const SessionHandling = (dispatch, setSessionCreated) => {
  function getSessionIDs() {
    const sessionIDs = localStorage.getItem('tabSessionIDs');
    return sessionIDs ? JSON.parse(sessionIDs) : [];
  }

  function setSessionIDs(sessionIDs) {
    localStorage.setItem('tabSessionIDs', JSON.stringify(sessionIDs));
  }

  function addSessionID(id) {
    const activeIDs = getSessionIDs();
    if (activeIDs.length < 1 && !sessionStorage.getItem('refresh')) {
      ApplicationLogout(dispatch);
    }

    sessionStorage.removeItem('refresh');

    if (!activeIDs.includes(id)) {
      activeIDs.push(id);
      setSessionIDs(activeIDs);
    }
  }

  function removeSessionID(id) {
    const sessionIDs = getSessionIDs();
    const updatedIDs = sessionIDs.filter((sid) => sid !== id);
    setSessionIDs(updatedIDs);
  }

  function SessionCreation() {
    let sessionID = sessionStorage.getItem('sessionID');

    if (!sessionID || window.name === '') {
      sessionID = `tab-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      sessionStorage.setItem('sessionID', sessionID);
      setSessionCreated(true);
      window.name = sessionID;
    }

    addSessionID(sessionID);

    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('refresh', true);
      removeSessionID(sessionID);
    });
  }

  if (document.visibilityState !== 'hidden') {
    SessionCreation();
  } else {
    window.addEventListener('visibilitychange', () => {
      if (document.visibilityState !== 'hidden') {
        SessionCreation();
      }
    });
  }
};

export default SessionHandling;
